export const introduce = {
  text: `### 使用方法
  + • 颜色从蓝渐进到红：颜色越红，说明距离减产日期越近。
  + 竖线是比特币历次减产时间，Stock-to-Flow模型假定每次减产以后因为比特币变得更加稀缺，所以价格会上升到一个更高的阶段。
  
  ### 指标原理
  + Stock-to-Flow是一个通过比特币的稀缺性来进行估值的模型。
  + 它默认稀缺资产自然存在价值，并且因为比特币过去的历史价格遵循S/F比率（S/F比率 = 流通中的比特币数量/新开采的比特币数量），所以假定未来的价格依旧会遵循S/F比率。
  
  ### 创作者
  该指标由 [Plan B](https://medium.com/@100trillionUSD/modeling-bitcoins-value-with-scarcity-91fa0fc03e25) 创作
  `,
  height: 1430,
};